import { RenderTexture, Text, useCursor } from '@react-three/drei'
import { useState } from 'react'

import { RenderTextureScene } from '@components/helpers'
import { WoodenSignModel } from '@components/models'
import { useIsTouch } from '@hooks'
import type { ThreeElements } from '@react-three/fiber'

type WoodenSignBillboardProps = ThreeElements['group'] & {
  label?: string
  level?: number
  labelProps?: Omit<React.ComponentProps<typeof Text>, 'children'>
  disabled?: boolean
  renderTextureKey?: string
}

export function WoodenSignBillboard({
  label,
  level,
  disabled,
  renderTextureKey,
  onClick,
  children,
  ...props
}: WoodenSignBillboardProps) {
  const isTouch = useIsTouch()
  const [hovered, setHovered] = useState(false)
  useCursor(hovered)

  const _disabled = disabled || !onClick

  return (
    <group {...props}>
      <WoodenSignModel
        highlight={!_disabled && (isTouch || hovered)}
        onClick={e => {
          if (_disabled) return
          e.stopPropagation()
          // @ts-expect-error wrong drei typings
          onClick?.()
        }}
        onPointerOver={e => {
          if (_disabled) return
          e.stopPropagation()
          setHovered(true)
        }}
        onPointerOut={e => {
          if (_disabled) return
          e.stopPropagation()
          setHovered(false)
        }}
        onPointerEnter={e => {
          if (_disabled) return
          e.stopPropagation()
          setHovered(true)
        }}
        onPointerLeave={e => {
          if (_disabled) return
          e.stopPropagation()
          setHovered(false)
        }}
      />
      <mesh position={[0, 1.65, 0]} scale={[3.5, 5, 1]} renderOrder={5}>
        <planeGeometry />
        <meshBasicMaterial transparent depthTest={false}>
          <RenderTexture key={renderTextureKey} attach="map" width={512} height={512}>
            <RenderTextureScene>
              {level && (
                <Text
                  font="/fonts/jaro.ttf"
                  anchorX="center"
                  anchorY="middle"
                  textAlign="center"
                  position={[7.5, -1.8, 0]}
                  scale={1.5}
                >
                  {level}
                </Text>
              )}
              <Text
                font="/fonts/jaro.ttf"
                anchorX="center"
                anchorY="middle"
                textAlign="center"
                {...props.labelProps}
              >
                {label}
              </Text>
              {children}
            </RenderTextureScene>
          </RenderTexture>
        </meshBasicMaterial>
      </mesh>
    </group>
  )
}
